import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext } from 'react'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import './signalProviderFollowers.css'
import AuthContext from 'contexte/AuthContext';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import { formatDate } from 'utils/date';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import { fetchSignalProviderFollowers } from 'services/copyInvestServices';
import { useParams, useSearchParams } from 'react-router-dom';

const SignalProviderFollowers = () => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const { signal_provider_uuid } = useParams()
  const [searchParams] = useSearchParams()
  console.log({searchParams})

  const [loading, setLoading] = useState(true);
  const [fetchLimit, setFetchLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [followers, setFollowers] = useState([]);

  const fetchData = async () => {
    try {
      const data = await fetchSignalProviderFollowers(user, signal_provider_uuid, page, fetchLimit)
      setFollowers(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [fetchLimit, page])

  function transformDataToTBody(data) {

    return data.map(item => {

      return {
        data: [
          item.full_name,
          item.total_invested,
          item.available,
          formatDate({date: item.created_at}),
          formatDate({date: item.follow_date}),
          item.status
        ]

      };
    });
  }



  return (
    <DashboardLayout page={t("pages_name.signal_provider_followers")}>
      <div>
                    <h1>{t('pages.signal_provider_followers.title', {sp_name: searchParams.get('sp_name')})}</h1>
        {!loading ? (
          <div>
            <div className='signal_provider_followers_title_component'>
              <div className='signal_provider_followers_filter_component'>

                <FilterComponent
                  limit={true}
                  fetchLimit={fetchLimit} setFetchLimit={setFetchLimit}
                />
              </div>
            </div>
            <Tableau
              thead={["Utilisateur", "Total Investi", "Disponible", 'Date de création de compte', 'Date de suivi', 'Status']}
              tbody={transformDataToTBody(followers)}
              limit={fetchLimit}
              pagination setPage={setPage} page={page}
            />
          </div>
        ) : (
          <div>Loading..</div>
        )}
      </div>
    </DashboardLayout>
  )
}

export default SignalProviderFollowers